import { render, staticRenderFns } from "./BlockTravelInformation.vue?vue&type=template&id=262d6e42&scoped=true&"
import script from "./BlockTravelInformation.vue?vue&type=script&lang=js&"
export * from "./BlockTravelInformation.vue?vue&type=script&lang=js&"
import style0 from "./BlockTravelInformation.vue?vue&type=style&index=0&id=262d6e42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d6e42",
  null
  
)

export default component.exports